import './TopBar.css';


const TopBar = (props) => {
    return (<div id="TopBar">
        <div className="logoDiv">
            { process.env.NODE_ENV === 'production'
                ? <img src="/images/2mwLogoWhite.png" alt="logo" />
                : <img src="/Images/2mwLogoWhite.png" alt="logo" />
            }
        </div>
    </div>);
}

export default TopBar;